import { createAction, handleActions } from "redux-actions";

// Actions
export const setMotosLoading = createAction("MOTOS_LOADING");
export const setMotosError = createAction("MOTOS_ERROR");
export const setDatosCotizacionPaso1 = createAction("MOTOS_SET_DATOS_PASO1");
export const setMotosIdCarrito = createAction("MOTOS_SET_ID_CARRITO");
export const limpiarDatosCotizacion = createAction("MOTOS_LIMPIAR_DATOS");

const initialState = {
  isLoading: false,
  error: null,
  idCarrito: null,
  idCotizacion: null,
  datosPaso1: null,
  datosVehiculo: null,
  plan: null,
  cotizacion: null,
  coberturas: null,
  coberturasPdf: null,
  valorTotal: null,
  carrito: null,
  textoDeclaracionConductor: '',
  esBloqueanteEmision: false,
  txtBloqueoEmision: ''
};

const reducerMotos = handleActions(
  {
    [setMotosLoading]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [setMotosError]: (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false
    }),
    [setMotosIdCarrito]: (state, action) => ({
      ...state,
      idCarrito: action.payload
    }),
    [setDatosCotizacionPaso1]: (state, action) => ({
      ...state,
      ...action.payload,
      isLoading: false,
      error: null
    }),
    [limpiarDatosCotizacion]: () => ({
      ...initialState
    })
  },
  initialState
);

export default reducerMotos;
